/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for arbitrary subtypes
 *
 * @category transaction-types
 */
export enum TransactionArbitrarySubtype {
    Message = 0,
    AliasAssignment,
    PollCreation,
    VoteCasting,
    HubAnnouncement,
    AccountInfo,
    AliasSale,
    AliasBuy,
    TopLevelDomainAssignment
}

